import React from 'react';
import MemberIcon from '../../member-icon/member-icon';

import './custom-project-filter-dropdown-item.scss';

const getPriorityID = (priorityName) => {

    switch(priorityName){
        case 'Urgent':
            return "urgent-icon";
        case 'High':
            return "high-icon";
        case 'Medium':
            return "medium-icon";
        case 'Low':
            return "low-icon";
    }

}

export const PriorityDropdownItem = ({name}) => {
    
    return(
        <div className='priority-dropdown-item'>
            <div className='priority-icon' id={getPriorityID(name)}>
            </div>
            <span className = 'priority-text'>
                {name}
            </span>
        </div>
    )
}

export const MemberDropdownItem = (memberItem) => {

    return(
        <div className = 'member-dropdown-item'>
            <div className='member-icon-container'>
                <MemberIcon
                    member={{...memberItem, userNameFull: memberItem.name}}
                />
            </div>
            <span className = 'member-text'>
                {memberItem.name}
            </span>
        </div>
    )
}